<script>
import store from '@shared/store'
import settings from '@shared/settings'
import i18n from '@shared/module/i18n'
import DynamicLinkMixin from '@shared/mixins/DynamicLinkMixin'

export default {
  mixins: [DynamicLinkMixin],
  methods: {
    startGetID({ reference, flowName, phoneNumber }) {
      if (settings.isWeb()) {
        this.redirectToApp(`/loan-application/${reference}`)
      } else {
        const customerPin = store.state.currentUser.pin
        this.initializeGetID(customerPin, reference, flowName, phoneNumber)
      }
    },
    getToken(customerPin) {
      const url = `/api/getid/${customerPin}/token${settings.isGetIdV2Supported() ? '/v2' : ''}`
      return this.$http.get(url)
    },
    initializeGetID(customerPin, reference, flowName, phoneNumber) {
      return this.getToken(customerPin)
          .then(response => {
            const token = response.data.token
            const customerData = store.state.currentUser
            const parameters = JSON.stringify({
              token: token,
              reference: reference || '-',
              firstName: customerData.firstName,
              lastName: customerData.lastName,
              pin: customerData.pin,
              phoneNumber: phoneNumber,
              birthDate: customerData.birthDate,
              locale: i18n.locale,
              getIdServiceUrl: this.$configuration.identityVerificationUrl,
              flowName
            })

            if (settings.isAndroid()) {
              window.getIdVerification.startVerification(parameters)
            } else if (settings.isIOS()) {
              window.webkit.messageHandlers.getIdMessageHandler.postMessage(parameters)
            }
          })
    }
  }
}
</script>
